export { default as SteppedPromotion } from './SteppedPromotion';
export { type SteppedPromotionProps, default as useSteppedPromotion } from './useSteppedPromotion';
